<template>
  <div class="recordReview">
    <el-container>
      <el-aside class="el-aside-l-wrap por">
        <a
          @click="showL = !showL"
          class="poa btn-l btn-switch"
          :class="{ cur: showL }"
        ></a>
        <transition name="el-zoom-in-left">
          <!-- v-if="!isShowAddReviewOpinions" -->
          <div class="el-aside-l por transition-box" v-show="showL">
            <div class="recordReview-l por">
              <a @click="resetChecked" class="reset" title="查看全篇">
                <i class="iconfont icon-other_zhongzhi"></i>
              </a>
              <div class="recordReview-l-catalog shadowlaw hlh60">
                <i class="iconfont icon-huodongmulupeizhi"></i>
                目录
              </div>
              <div class="recordReview-l-treeCon shadowlaw">
                <el-collapse v-model="activeNames">
                  <el-collapse-item
                    name="1"
                    :class="{ chapter: centerTextType == 'chapter' }"
                  >
                    <span slot="title" class="title-collapse" :title="title">{{
                      title
                    }}</span>
                    <happy-scroll size="3" color="#c1c4c6" :hide-horizontal="true" resize>
                      <!-- :default-expanded-keys="[1]"
											:default-checked-keys="[5]" -->

                      <div>
                        <el-tree
                          :data="treeData"
                          node-key="id"
                          :current-node-key="currentKey"
                          :props="defaultProps"
                          v-loading="loadingCategory"
                          @check-change="handleNodeClick"
                          ref="tree"
                          check-on-click-node
                          check-strictly
                          :default-expanded-keys="defaultkey"
                        ></el-tree>
                      </div>
                    </happy-scroll>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
            <div class="recordReview-l-list shadowlaw">
              <div class="recordReview-l-catalog shadowlaw shadowR hlh60">
                <i class="iconfont icon-ai-list"></i>
                审查意见列表
              </div>
              <div class="recordReview-l-table tableBox tableBoxRecordReview por">
                <el-table
                  :data="reviewOpinionData"
                  stripe
                  height="210"
                  v-loading="loadingCheckDataList"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="item_id__content"
                    label="对应条款"
                    min-width="32%"
                    align="left"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <span @click="editOpinionFun(scope.row.id)">
                        {{
                          scope.row.item_id__content.length > 30
                            ? scope.row.item_id__content.substr(0, 30) + "..."
                            : scope.row.item_id__content
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="advise_type"
                    label="类型"
                    min-width="16%"
                    align="left"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <el-table-column
                    label="提交时间"
                    min-width="30%"
                    align="center"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.create_time }}
                      <!-- {{handleTime(scope.row.create_time)}} -->
                    </template>
                  </el-table-column>
                </el-table>
                <a
                  class="more fr"
                  @click="toReviewOpinionFun"
                  v-if="reviewOpinionData && reviewOpinionData.length > 5"
                >
                  more&gt;&gt;
                  <!-- <i class="iconfont icon-changjiantou"></i> -->
                </a>
              </div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-left">
          <div
            class="el-aside-l por transition-box el-aside-l-addReviewOpinions"
            v-show="showL"
            v-if="isShowAddReviewOpinions"
          >
            <addReviewOpinions
              @parentAddReviewOpinionsFun="parentAddReviewOpinionsFun"
              @parentDelReviewOpinionsFun="parentDelReviewOpinionsFun"
              :data="termsData"
              :currentKey="currentKey"
              :curMode="curMode"
              ref="addReviewOpinions"
            ></addReviewOpinions>
          </div>
        </transition>
      </el-aside>
      <el-main class="recordReview-c-wrap">
        <div class="shadowlaw recordReview-c por">
          <div class="recordReview-c-operation poa">
            <div class="operation">
              <a class="new f_transition add" @click="addOpinionFun">
                <i class="iconfont icon-wancheng1"></i>
                添加意见
              </a>
              <!-- <a class="new f_transition upload" @click="uploadAgainFun">
									<i class="iconfont icon-shangchuan"></i>
									重新上传
								</a> -->
              <a
                class="new f_transition report"
                @click="generateReportFun"
                v-loading="loadingReport"
              >
                <i class="iconfont icon-baogao"></i>
                生成报告
              </a>
            </div>
          </div>
          <div class="fileBoxCon fileBoxConRecordReviewCenter">
            <div class="fileBoxConRecordReviewCenterCon">
              <happy-scroll size="3" color="#c1c4c6" :hide-horizontal="true" resize>
                <div class="con">
                  <h2 class="title" v-if="currentKey == uuid">{{ title }}</h2>
                  <!-- <p class="subtitle" v-if="currentKey==uuid">{{subTitle}}</p>
									<p class="paragraphMain" v-if="currentKey==uuid">
										为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。
									</p> -->
                  <!-- 标题下方的简介 -->
                  <p class="paragraphMain" v-if="head_content && currentKey == uuid"></p>

                  <div v-if="centerTextType == 'chapter'">
                    <div v-for="(item, index) in chooseData" :key="index">
                      <h3
                        class="chapter"
                        @click="centerCurIdFun(item)"
                        v-html="item.labelHtml"
                      ></h3>
                      <!-- 选中条之后再每一句有事件 整条没有事件 -->
                      <div v-if="chooseData && chooseData[0].children.length == 1">
                        <p
                          class="paragraph"
                          v-for="(inside, index) in item.children"
                          :key="index"
                        >
                          <!-- 这一条中不止一句话的时候 这句话不添加事件 -->
                          <!-- 只有法律法规库才可以句子检索 -->
                          <!-- v-if="inside.label.split('。').length-1>1&&radioR=='CLKL'" -->
                          <span v-if="radioR == 'CLKL'">
                            <span
                              v-for="(itemInside, index) in splitData(inside.labelHtml)"
                              :key="index"
                              :class="{ cur: index == sentenceCur }"
                              @click.stop="
                                clickSentenceFun(splitData(inside.label)[index], index)
                              "
                            >
                              <!-- {{ itemInside + "。" }} -->
                              <i v-html="itemInside"></i>。
                            </span>
                          </span>
                          <span v-else>
                            <span
                              v-for="(itemInside, index) in splitData(inside.labelHtml)"
                              :key="index"
                            >
                              <!-- {{ itemInside + "。" }} -->
                              <i v-html="itemInside"></i>。
                            </span>
                          </span>
                        </p>
                      </div>
                      <!-- 默认整篇显示 整条有事件 每一句没有事件-->
                      <div v-else>
                        <p
                          class="paragraph"
                          @click="centerCurIdFun(inside)"
                          v-for="(inside, index) in item.children"
                          :key="index"
                        >
                          <span>
                            <span
                              v-for="(itemInside, index) in splitData(inside.labelHtml)"
                              :key="index"
                              :class="{ cur: index == sentenceCur }"
                            >
                              <!-- {{ itemInside + "。" }} -->
                              <i v-html="itemInside"></i>。
                            </span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="centerTextType == 'items'">
                    <div>
                      <!-- <h3 class="chapter">{{item.label}}</h3> -->
                      <!-- <p class="paragraph" @click="centerCurIdFun(inside)" v-for="(inside,index) in chooseData" :key="index">{{inside.label}}</p> -->

                      <!-- 选中条之后再每一句有事件 整条没有事件 -->
                      <!-- currentKey.indexOf('_')>0是为了避免条目审查只有一段 可直接点击句子进行检索 但是item_id不存在 导致句子检索报错 -->
                      <div
                        v-if="
                          chooseData &&
                          chooseData.length == 1 &&
                          currentKey.indexOf('_') > 0
                        "
                      >
                        <p
                          class="paragraph"
                          v-for="(inside, index) in chooseData"
                          :key="index"
                        >
                          <!-- 选中条之后再添加事件checkedTreeObj选中的数据 -->
                          <!-- 这一条中不止一句话的时候 这句话不添加事件 -->
                          <!-- 只有法律法规库才可以句子检索 -->
                          <!-- v-if="inside.label.split('。').length-1>1&&radioR=='CLKL'" -->
                          <span v-if="radioR == 'CLKL'">
                            <span
                              v-for="(itemInside, index) in splitData(inside.labelHtml)"
                              :key="index"
                              :class="{ cur: index == sentenceCur }"
                              @click.stop="
                                clickSentenceFun(splitData(inside.label)[index], index)
                              "
                            >
                              <!-- {{ itemInside + "。" }} -->
                              <i v-html="itemInside"></i>。
                            </span>
                          </span>
                          <span v-else>
                            <span
                              v-for="(itemInside, index) in splitData(inside.labelHtml)"
                              :key="index"
                            >
                              <!-- {{ itemInside + "。" }} -->
                              <i v-html="itemInside"></i>。
                            </span>
                          </span>
                        </p>
                      </div>
                      <!-- 默认整篇显示 整条有事件 每一句没有事件-->
                      <div v-else>
                        <p
                          class="paragraph"
                          @click="centerCurIdFun(inside)"
                          v-for="(inside, index) in chooseData"
                          :key="index"
                        >
                          <span>
                            <span
                              v-for="(itemInside, index) in splitData(inside.labelHtml)"
                              :key="index"
                              :class="{ cur: index == sentenceCur }"
                            >
                              <!-- {{ itemInside + "。" }} -->
                              <i v-html="itemInside"></i>。
                            </span>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </happy-scroll>
            </div>
          </div>
        </div>
      </el-main>
      <el-aside class="el-aside-r-wrap por">
        <a
          @click="showR = !showR"
          class="poa btn-l btn-switch"
          :class="{ cur: showR }"
        ></a>
        <transition name="el-zoom-in-left">
          <div width="200px" class="el-aside-r por transition-box" v-show="showR">
            <div class="recordReview-l">
              <div class="shadowlaw shadowl recordReview-r-catalog-firstTitle">
                <el-radio-group
                  v-model="radioR"
                  @change="radioChange()"
                  v-if="firstTitleData && firstTitleData.length > 0"
                >
                  <el-radio-button
                    v-for="(item, index) in firstTitleData"
                    :key="index"
                    :label="item.id"
                    :style="{
                      width: 100 / firstTitleData.length + '%',
                    }"
                    >{{ item.label }}</el-radio-button
                  >
                </el-radio-group>
              </div>
              <div
                class="recordReview-r-con shadowlaw shadowl"
                v-loading="loadingcnkiData"
              >
                <div class="search-box search-box-recordReview" v-if="radioR != 'LFZL'">
                  <!-- 高级检索表单 -->
                  <search-by-advancedform
                    v-model="advancedList"
                    :selectType="radioR"
                    :currentKey="currentKey"
                    :checkedTreeObj="checkedTreeObj"
                    @advanceFormChange="advanceFormChange"
                    :key="radioR + currentKey"
                    ref="advance_form"
                  />
                </div>
                <div
                  class="recordReview-r-catalog-secondTitle"
                  v-loading="loadingSecondTitle"
                  v-if="radioR != 'LFZL'"
                >
                  <vue-seamless-scroll
                    :class-option="optionSwitch1"
                    class="seamless-warp3"
                    :data="secondTitleData"
                    v-if="secondTitleData && secondTitleData.length > 0"
                    :key="radioR"
                  >
                    <ul
                      class="item clearfix"
                      :style="{
                        minWidth: '500px',
                        width: maxSecondTitleStrLength * 20 + 20 + 'px',
                      }"
                    >
                      <li
                        v-for="(item, index) in secondTitleData"
                        :key="index"
                        @click="getidFun(item.key, index)"
                        :class="{ cur: index == cur }"
                      >
                        {{ item.value }}
                      </li>
                    </ul>
                  </vue-seamless-scroll>
                </div>
                <div class="recordReview-r-con-main">
                  <!-- <p class="num fr">共 {{recommendCnkiDataSum}} 条</p> -->
                  <div class="fileBoxCon fileBoxConRecordReview-r">
                    <!-- 法律法规库 只有法律法规库才有句子检索-->
                    <happy-scroll
                      size="3"
                      color="#c1c4c6"
                      :hide-horizontal="true"
                      resize
                      v-if="radioR == 'CLKL'"
                      :key="secondId"
                    >
                      <!-- <div class="con" v-if="recommendCnkiDataSum>0"> -->
                      <div
                        class="con"
                        v-if="
                          total > 0 && recommendCnkiData && recommendCnkiData.length > 0
                        "
                      >
                        <div
                          class="fileBoxConRecordReview-r-list"
                          v-for="(item, index) in recommendCnkiData"
                          :key="index"
                        >
                          <!-- 只有整篇审查区分整篇、章不显示正文快照 条显示条的全文；要是条目审查就直接都显示条的正文全文 -->
                          <div
                            class="fileBoxConRecordReview-r-list-b"
                            v-if="
                              item._source.quanWen ||
                              (item.highlight && item.highlight.quanWen)
                            "
                          >
                            <!-- 点击句子的时候 -->
                            <!-- <p v-if="sentenceContentCur" v-html="highlightFontFun(item._source.quanWen)"></p> -->
                            <div
                              v-if="
                                /*sentenceContentCur &&*/
                                item.highlight && item.highlight.quanWen
                              "
                            >
                              <div>
                                <p
                                  v-html="item.highlight.quanWen"
                                  class="highlightSentence"
                                ></p>
                              </div>
                            </div>
                            <!-- 点击非句子的时候 -->
                            <p v-else>{{ item._source.quanWen }}</p>
                          </div>
                          <div
                            class="fileBoxConRecordReview-r-list-t por"
                            :class="{
                              'fileBoxConRecordReview-r-list-t-after': !(
                                (currentKey.indexOf('_') > 0 &&
                                  checkedTreeObj.tag != 'c') ||
                                reviewType == 'item'
                              ),
                            }"
                          >
                            <a
                              class="poa gain"
                              @click="obtainLawFun(item)"
                              title="添加依据"
                            >
                              <i class="iconfont icon-xuqiutiaomushu"></i>
                            </a>
                            <!-- <a class="poa more" :href="cnkiUrl+'/KCMS/detail/detail.aspx?dbcode='+item.dbcode.value+'&dbname='+item.biaoMing.value+'&filename='+item.wenJianMing.value" target="_blank">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a> -->
                            <!-- <a class="poa more">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a> -->
                            <div class="clearfix lastItem">
                              <!-- 整篇审查---整篇的和条的文件名不一样 整篇的为bianHao 条的为tiaoMuBianHao -->
                              <!-- 条目审查只有条目审查tiaoMuBianHao -->
                              <p
                                class="b text-ellipsis fl"
                                :title="item._source.zhongWenBiaoTi"
                                v-if="item._source.tiaoMuBianHao  && reviewType == 'item'"
                              >
                                <!-- <span>来源: </span>  -->
                                <a
                                  v-if="
                                    item._source.zhongWenBiaoTi &&
                                    item._source.zhongWenBiaoTi != -1107
                                  "
                                  target="_blank"
                                  :href="
                                    '/#/cnkiDetail?b=4&url=' +
                                    encodeURIComponent(
                                      cnkiUrl +
                                        '/KCMS/detail/detail.aspx?dbcode=' +
                                        item._source.biaoMing.substring(0, 4) +
                                        'T&dbname=' +
                                        item._source.biaoMing +
                                        '&filename=' +
                                        item._source.tiaoMuBianHao
                                    )
                                  "
                                  ><i v-html="item._source.zhongWenBiaoTi"></i
                                ></a>
                              </p>
                              <p
                                class="b text-ellipsis fl"
                                :title="item._source.zhongWenBiaoTi"
                                v-if="item._source.bianHao && reviewType == 'file'"
                              >
                                <!-- <span>来源: </span>  -->
                                <a
                                  v-if="
                                    item._source.zhongWenBiaoTi &&
                                    item._source.zhongWenBiaoTi != -1107
                                  "
                                  target="_blank"
                                  :href="
                                    '/#/cnkiDetail?b=4&url=' +
                                    encodeURIComponent(
                                      cnkiUrl +
                                        '/KCMS/detail/detail.aspx?dbcode=' +
                                        item._source.biaoMing.substring(0, 4) +
                                        '&dbname=' +
                                        item._source.biaoMing +
                                        '&filename=' +
                                        item._source.bianHao
                                    )
                                  "
                                  ><i v-html="item._source.zhongWenBiaoTi"></i
                                ></a>
                              </p>

                              <p
                                class="y text-ellipsis fl"
                                :title="item._source.faBuJiGuan"
                              >
                                <!-- <span>机构: </span>  -->
                                <i
                                  v-if="
                                    item._source.faBuJiGuan &&
                                    item._source.faBuJiGuan != -1107
                                  "
                                  >{{ item._source.faBuJiGuan }}</i
                                >
                              </p>
                              <p
                                class="fl text-ellipsis time"
                                :title="item._source.faBuRiQi"
                              >
                                <!-- <span>{{item._source.faBu_riQi.key}}</span> -->
                                <i
                                  v-if="
                                    item._source.faBuRiQi &&
                                    item._source.faBuRiQi != -1107
                                  "
                                  >{{ item._source.faBuRiQi }}</i
                                >
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- <div class="fileBoxConRecordReview-r-list">
													<div class="fileBoxConRecordReview-r-list-t por">
														<a class="poa gain">
															<i class="iconfont icon-xuqiutiaomushu"></i>
														</a>
														<a class="poa more">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a>
														<p class="b"><span>[ 所属法规 ]</span> 云南省艾滋病防治条例</p>
														<p class="y"><span>[ 所属法规 ]</span> 全国人民代表大会常务委员会</p>   
														<p><span>[ 发布日期 ]</span> 2013-06-29</p>
													</div>
													<div class="fileBoxConRecordReview-r-list-b">
														第一章 总则第一条 为了预防、控制艾滋病的发生和流行，保障人体健康和公共卫生安全，根据《中华人民共和国传染病防治法》、《艾滋病防治条例》等法律、行政法规，结合本省实际，制定本条例。第二条 本省行政区域内艾滋病防治及其监督管理工作，适用本条例。
													</div>
												</div>-->
                      </div>
                      <div class="con" v-else>
                        <p class="noData">暂无数据</p>
                      </div>
                    </happy-scroll>

                    <!-- 政报公报库 -->
                    <happy-scroll
                      size="3"
                      color="#c1c4c6"
                      :hide-horizontal="true"
                      resize
                      v-if="radioR == 'CJFZ'"
                    >
                      <!-- <div class="con" v-if="recommendCnkiDataSum>0"> -->
                      <div
                        class="con"
                        v-if="
                          total > 0 && recommendCnkiData && recommendCnkiData.length > 0
                        "
                      >
                        <div
                          class="fileBoxConRecordReview-r-list"
                          v-for="(item, index) in recommendCnkiData"
                          :key="index"
                        >
                          <div
                            class="fileBoxConRecordReview-r-list-t por fileBoxConRecordReview-r-list-t-after"
                          >
                            <a
                              class="poa gain"
                              @click="obtainLawFun(item)"
                              title="添加依据"
                            >
                              <i class="iconfont icon-xuqiutiaomushu"></i>
                            </a>
                            <!-- dbname表名 filename文件名-->
                            <!-- <a class="poa more" :href="cnkiUrl+'/KCMS/detail/detail.aspx?dbcode='+item.biaoMing.value+'&dbname='+item.biaoMing.value+'&filename='+item.wenJianMing.value" target="_blank"> -->
                            <!-- <a class="poa more" :href="cnkiUrl+'/KCMS/detail/detail.aspx?dbcode='+item.dbcode.value+'&dbname='+item.biaoMing.value+'&filename='+item.wenJianMing.value" target="_blank">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a> -->
                            <!-- <a class="poa more">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a> -->
                            <div class="clearfix lastItem">
                              <p
                                class="b text-ellipsis fl"
                                :title="item._source.pianMing"
                              >
                                <!-- <span>来源: </span>   -->
                                <a
                                  v-if="
                                    item._source.pianMing &&
                                    item._source.pianMing != -1107
                                  "
                                  target="_blank"
                                  :href="
                                    '/#/cnkiDetail?b=4&type=3&url=' +
                                    encodeURIComponent(
                                      cnkiUrlZb +
                                        '/urtpweb/detail?sysid=23&resid=1&filename=' +
                                        item._source.wenJianMing +
                                        '&tablename=' +
                                        item._source.biaoMing
                                    )
                                  "
                                  ><i v-html="item._source.pianMing"></i
                                ></a>
                              </p>
                              <p
                                class="y text-ellipsis fl"
                                :title="item._source.zhongWenKanMing"
                              >
                                <!-- <span>机构: </span>  -->
                                <i
                                  v-if="
                                    item._source.zhongWenKanMing &&
                                    item._source.zhongWenKanMing != -1107
                                  "
                                  >{{ item._source.zhongWenKanMing }}</i
                                >
                              </p>
                              <p
                                class="fl text-ellipsis time"
                                :title="item._source.chuBanRiQi"
                              >
                                <!-- <span>{{item.chuBanRiQi</span>  -->
                                <i
                                  v-if="
                                    item._source.chuBanRiQi &&
                                    item._source.chuBanRiQi != -1107
                                  "
                                  >{{ item._source.chuBanRiQi }}</i
                                >
                              </p>
                            </div>
                          </div>

                          <!-- 【政报公报库】与【参考知识库】下推送的知识内容，在任何条件下都不需要显示‘摘要/正文快照’信息 -->
                          <!-- <div class="fileBoxConRecordReview-r-list-b" v-if="item.zhongWen_zhaiYao.value&&item.zhongWen_zhaiYao.value!=-1107&&((currentKey.indexOf('_')>0&&checkedTreeObj.tag!='c')||reviewType=='item')" >
														<!- 点击句子的时候 ->
														<p v-if="sentenceContentCur" v-html="highlightFontFun(item.zhongWen_zhaiYao.value)"></p>
														<!- 点击非句子的时候 ->
														<p v-else>{{item.zhongWen_zhaiYao.value}}</p>
													</div> -->
                        </div>
                        <!-- <div class="fileBoxConRecordReview-r-list">
													<div class="fileBoxConRecordReview-r-list-t por">
														<a class="poa gain">
															<i class="iconfont icon-xuqiutiaomushu"></i>
														</a>
														<a class="poa more">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a>
														<p class="b"><span>[ 所属法规 ]</span> 云南省艾滋病防治条例</p>
														<p class="y"><span>[ 所属法规 ]</span> 全国人民代表大会常务委员会</p>   
														<p><span>[ 发布日期 ]</span> 2013-06-29</p>
													</div>
													<div class="fileBoxConRecordReview-r-list-b">
														第一章 总则第一条 为了预防、控制艾滋病的发生和流行，保障人体健康和公共卫生安全，根据《中华人民共和国传染病防治法》、《艾滋病防治条例》等法律、行政法规，结合本省实际，制定本条例。第二条 本省行政区域内艾滋病防治及其监督管理工作，适用本条例。
													</div>
												</div>-->
                      </div>
                      <div class="con" v-else>
                        <p class="noData">暂无数据</p>
                      </div>
                    </happy-scroll>

                    <!-- 参考知识库 -->
                    <happy-scroll
                      size="3"
                      color="#c1c4c6"
                      :hide-horizontal="true"
                      resize
                      v-if="radioR == 'CLKD'"
                    >
                      <!-- <div class="con" v-if="recommendCnkiDataSum>0"> -->
                      <div
                        class="con"
                        v-if="
                          total > 0 && recommendCnkiData && recommendCnkiData.length > 0
                        "
                      >
                        <div
                          class="fileBoxConRecordReview-r-list"
                          v-for="(item, index) in recommendCnkiData"
                          :key="index"
                        >
                          <div
                            class="fileBoxConRecordReview-r-list-b"
                            v-if="item._source.zhongWenZhaiYao"
                          >
                            <p v-html="item._source.zhongWenZhaiYao"></p>
                          </div>
                          <div
                            class="fileBoxConRecordReview-r-list-t por"
                            :class="{
                              'fileBoxConRecordReview-r-list-t-after': !item._source
                                .zhongWenZhaiYao,
                            }"
                          >
                            <a
                              class="poa gain"
                              @click="obtainLawFun(item)"
                              title="添加依据"
                            >
                              <i class="iconfont icon-xuqiutiaomushu"></i>
                            </a>
                            <!-- <a class="poa more" :href="cnkiUrl+'/KCMS/detail/detail.aspx?dbcode='+item.dbcode.value+'&dbname='+item.biaoMing.value+'&filename='+item.wenJianMing.value" target="_blank">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a> -->
                            <!-- <a class="poa more">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a> -->
                            <div class="clearfix lastItem">
                              <p
                                class="b text-ellipsis fl"
                                :title="item._source.pianMing"
                                :class="{
                                  width3:
                                    item._source.chuPanDanWei && item._source.zuoZhe,
                                }"
                              >
                                <!-- <span>来源: </span>   -->
                                <a
                                  v-if="
                                    item._source.pianMing &&
                                    item._source.pianMing != -1107
                                  "
                                  target="_blank"
                                  :href="
                                    '/#/cnkiDetail?b=4&url=' +
                                    encodeURIComponent(
                                      cnkiUrl +
                                        '/KCMS/detail/detail.aspx?dbcode=' +
                                        item._source.biaoMing.substring(0, 4) +
                                        '&dbname=' +
                                        item._source.biaoMing +
                                        '&filename=' +
                                        item._source.wenJianMing
                                    )
                                  "
                                  >{{ item._source.pianMing }}</a
                                >
                              </p>
                              <p
                                class="y text-ellipsis fl"
                                :title="item._source.chuPanDanWei"
                              >
                                <!-- <span>出版单位: </span>   -->
                                <i
                                  v-if="
                                    item._source.chuPanDanWei &&
                                    item._source.chuPanDanWei != -1107
                                  "
                                  >{{ item._source.chuPanDanWei }}</i
                                >
                              </p>
                              <p class="y text-ellipsis fl" :title="item._source.zuoZhe">
                                <!-- <span>作者: </span>   -->
                                <i
                                  v-if="
                                    item._source.zuoZhe && item._source.zuoZhe != -1107
                                  "
                                  >{{ item._source.zuoZhe }}</i
                                >
                              </p>
                              <p
                                class="fl text-ellipsis time"
                                :title="item._source.chuBanRiQi"
                              >
                                <!-- <span>{{item._source.chuBanRiQi</span> -->
                                <i
                                  v-if="
                                    item._source.chuBanRiQi &&
                                    item._source.chuBanRiQi != -1107
                                  "
                                  >{{ item._source.chuBanRiQi }}</i
                                >
                              </p>
                            </div>
                          </div>

                          <!-- 【政报公报库】与【参考知识库】下推送的知识内容，在任何条件下都不需要显示‘摘要/正文快照’信息 -->
                          <!-- <div class="fileBoxConRecordReview-r-list-b" v-if="item.zhengWen_kuaiZhao.value&&item.zhengWen_kuaiZhao.value!=-1107&&((currentKey.indexOf('_')>0&&checkedTreeObj.tag!='c')||reviewType=='item')" >
														<!- 点击句子的时候 ->
														<p v-if="sentenceContentCur" v-html="highlightFontFun(item.zhengWen_kuaiZhao.value)"></p>
														<!- 点击非句子的时候 ->
														<p v-else>{{item.zhengWen_kuaiZhao.value}}</p>
													</div> -->
                        </div>
                        <!-- <div class="fileBoxConRecordReview-r-list">
													<div class="fileBoxConRecordReview-r-list-t por">
														<a class="poa gain">
															<i class="iconfont icon-xuqiutiaomushu"></i>
														</a>
														<a class="poa more">
															more 
															<i class="iconfont icon-changjiantou"></i>
														</a>
														<p class="b"><span>[ 所属法规 ]</span> 云南省艾滋病防治条例</p>
														<p class="y"><span>[ 所属法规 ]</span> 全国人民代表大会常务委员会</p>   
														<p><span>[ 发布日期 ]</span> 2013-06-29</p>
													</div>
													<div class="fileBoxConRecordReview-r-list-b">
														第一章 总则第一条 为了预防、控制艾滋病的发生和流行，保障人体健康和公共卫生安全，根据《中华人民共和国传染病防治法》、《艾滋病防治条例》等法律、行政法规，结合本省实际，制定本条例。第二条 本省行政区域内艾滋病防治及其监督管理工作，适用本条例。
													</div>
												</div>-->
                      </div>
                      <div class="con" v-else>
                        <p class="noData">暂无数据</p>
                      </div>
                    </happy-scroll>
                    <!-- 立法资料 -->
                    <happy-scroll
                      size="3"
                      color="#c1c4c6"
                      :hide-horizontal="true"
                      resize
                      v-if="radioR == 'LFZL'"
                    >
                      <!-- <div class="con" v-if="recommendCnkiDataSum>0"> -->
                      <div
                        class="con"
                        v-if="recommendCnkiData && recommendCnkiData.length > 0"
                      >
                        <div
                          class="fileBoxConRecordReview-r-list"
                          v-for="(item, index) in recommendCnkiData"
                          :key="index"
                        >
                          <div
                            class="fileBoxConRecordReview-r-list-t por fileBoxConRecordReview-r-list-t-after"
                          >
                            <div class="clearfix lastItem">
                              <p :title="item.filename" class="b text-ellipsis fl">
                                <a target="_blank" :href="item.urlPath"
                                  ><i>{{ item.filename }}</i></a
                                >
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="con" v-else>
                        <p class="noData">暂无数据</p>
                      </div>
                    </happy-scroll>
                  </div>
                  <div class="page clearfix pageReviewDetail tac" v-if="radioR != 'LFZL'">
                    <el-pagination
                      @size-change="handleSizeChangeDeclare"
                      @current-change="handleCurrentChangeDeclare"
                      :current-page.sync="currentPageDeclare"
                      :page-size="pageSize"
                      background
                      small
                      layout="total ,prev, pager, next, jumper"
                      :total="total"
                    ></el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </el-aside>
    </el-container>
    <!-- 重新上传 -->
    <uploadAgain
      ref="uploadAgain"
      @uploadAgainFunParent="init"
      data="uploadAgain"
    ></uploadAgain>
  </div>
</template>
<script>
//编辑审查意见
import addReviewOpinions from "./addReviewOpinions.vue";
//重新上传
import uploadAgain from "./uploadAgain.vue";
import SearchByAdvancedform from "./SearchByAdvancedform.vue";
export default {
  components: {
    addReviewOpinions,
    uploadAgain,
    SearchByAdvancedform,
  },
  data() {
    return {
      cnkiUrl: this.url.cnkiUrl, //跳转知网详情
      cnkiUrlZb: this.url.cnkiUrlZb, //政报公报库跳转知网详情
      uuid: "", //需要解析的文件uuid
      process: Number, //审查进度

      //右侧start=====
      showR: true, //展开收起
      radioR: "", //右侧一级标签
      firstTitleData: [], //一级标签数据
      secondTitleData: [], //二级标签数据
      maxSecondTitleStrLength: 0, //二级标签中的最长字符串
      loadingSecondTitle: false, //二级标签及知网数据
      recommendCnkiData: [], //推荐知网数据
      recommendCnkiDataSum: Number, //推荐知网数据总条数
      loadingcnkiData: false, //右侧推荐列表
      cur: 0, //右侧二级导航当前index Number
      secondId: "", //二级导航选中
      // num: null, //右侧二级的数量null
      recommendedSearchListData: [], //检索推荐文字

      //检索框
      inputTxt: "", //input输入的值
      selectTxt: "", //下拉列表的值 默认选中主题
      selectData: [], //检索栏目-下拉框中的值

      //分页start==
      currentPageDeclare: 1, //当前页
      total: 0, // 总共条数
      pageSize: 20, //每页的数量
      //分页end==
      reviewType: "", //审查类型

      //右侧end=====

      //左侧start=====
      showL: true, //展开收起
      activeNames: "1",
      reviewOpinionData: [], //左侧审查意见列表数据
      subTitle: "（2006年11月30日云南省第十届人民代表大会常务委员会第二十六次会议通过）", //副标题
      treeData: [], //左侧导航树
      defaultProps: {
        children: "children",
        label: "label",
      },
      currentKey: "", //树形控件-当前选中的节点 m默认为0时展示标题和副标题
      defaultkey: [], //默认选中节点
      checkedTreeObj: {}, //导航树选中的对象
      // reviewOpinionData:[],//审查意见列表数据
      //编辑审查意见
      isShowAddReviewOpinions: false,
      termsData: [], //对应条款数据
      curMode: "", //编辑审查意见当前的模式 添加 add 编辑 edit
      type: "修改", //默认修改

      //左侧end=====

      //中间start===
      chooseData: [], //选中的值
      title: "", //标题
      centerTextType: "", //中间数据显示的样式 "chapter"章节 "items"条
      loadingReport: false, //生成报告
      sentenceCur: Number, //当前高亮的句子索引
      sentenceContentCur: "", //选中的句子
      //中间end===

      head_content: "", //标题下方的简介
      sensitiveWords: [], //中间敏感词标黄
      advancedList: [], //高级检索数据
      searchType: "searchAdvance", //检索类型-高级检索/一框检索
      advancedShow: false, //高级检索弹框显示
      searchUrl: {
        search: "/japi/lawAIRec/select",
        searchAdvance: "/japi/lawAIRec/highcheck",
      },
      cjfdList: [], //右侧标红敏感词
      loadingCategory: false, //目录
      loadingCheckDataList: false, //审查意见列表
    };
  },
  created() {
    this.init(); //初始
  },
  methods: {
    // 标下划线
    getUnderLineStr(val, keywords) {
      if (!val || keywords.length == 0) {
        return val;
      }
      let textArr = keywords;
      var reg = new RegExp(textArr.join("|"), "g");
      if (reg) {
        return val.replace(reg, `<font style="text-decoration:underline">$&</font>`);
      } else {
        return val;
      }
    },
    // 高亮关键词
    getHightlightStr(val, keywords, color = "red") {
      if (!val || val.indexOf("<font") > -1 || keywords.length == 0) {
        return val;
      }
      let textArr = keywords;
      var reg = new RegExp(textArr.join("|"), "g");
      if (reg) {
        return val.replace(reg, `<font color='${color}'>$&</font>`);
      } else {
        return val;
      }
    },
    // 右侧检索====
    // 获取检索建议数据
    querySearch(queryString, cb) {
      // console.log(queryString);
      //仅为输入时的搜索
      // if(!queryString){
      this.axios.get("/japi/lawAIRec/suggester?keyword=" + this.inputTxt).then((res) => {
        console.log("获取检索建议数据======");
        console.log(res);
        if (res.data.code == 200) {
          this.recommendedSearchListData = res.data.data.map((item, index) => {
            return {
              text: item,
            };
          });
          // 调用 callback 返回建议列表的数据
          cb(this.recommendedSearchListData);
          // this.recommendedSearchListData=JSON.parse(JSON.stringify(this.recommendedSearchListData).replace(/text/g,'value'));
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
      // }
      // //输入完成时的点击enter事件触发，需配合el :select-when-unmatched="true"同时使用
      // else{
      // 	this.searchFun();
      // }
    },
    //获取检索栏目数据
    getSelectDataFun() {
      this.axios.get("/japi/knowledge/get_select_column/").then((res) => {
        console.log("检索栏目数据======");
        console.log(res);
        if (res.data.code == 200) {
          this.selectData = res.data.data;
          this.selectTxt = "theme";
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    // 点击高级检索按钮
    advanceFormChange(formArr) {
      this.advancedList = formArr;
      this.currentPageDeclare = 1;
      if (formArr) {
        // 有数据走高级检索接口
        this.searchType = "searchAdvance";

        let arr = formArr.filter((item) => !item.type);
        if (arr.some((item) => !item.field || !item.compare || !item.value)) {
          this.$message({
            message: "高级检索条件每项为必填，请仔细检查",
            type: "warning",
            duration: 3000,
          });
          return;
        }
        this.dealSecondTitleDataFun("", "", "search");
      } else {
        // 重置走初始化接口
        this.searchType = undefined;
        this.dealSecondTitleDataFun(1);
      }
    },
    handleAdvanceSearch() {
      let arr = this.advancedList.filter((item) => !item.type);
      if (arr.some((item) => !item.field || !item.compare || !item.value)) {
        this.$message({
          message: "高级检索条件每项为必填，请仔细检查",
          type: "warning",
          duration: 3000,
        });
        return;
      }
      this.currentPageDeclare = 1;
      this.dealSecondTitleDataFun("", "", "search");
    },
    //点击检索按钮
    searchFun() {
      this.searchType = "search";
      this.inputTxt = this.inputTxt.trim();
      if (this.inputTxt) {
        //this.recommendCnkiDataFun(1);//推荐知网数据
        this.currentPageDeclare = 1;
        this.dealSecondTitleDataFun("", "", "search"); //获取二级标签数据-检索结果！！
      } else {
        this.$message({
          message: "请输入检索内容",
          type: "warning",
          duration: 1000,
        });
        //input获取焦点
        this.$nextTick(() => {
          this.$refs.ipt.focus();
        });
      }
    },

    //初始
    init() {
      this.uuid = window.localStorage.getItem("uuid");
      this.reviewType = window.localStorage.getItem("reviewType"); //获取审查类型
      this.currentKey = this.uuid; //默认全篇 综合意见

      this.fetchSensitiveWords();
      // this.getFileDataFun(); //解析文件方法

      this.recommendCnkiDataTitleFun(); //右侧推荐知网数据标签
      // this.recommendCnkiDataFun(1);//右侧推荐知网数据

      // this.getSelectDataFun();//获取检索栏目数据
    },
    initByPk() {
      let pk = window.localStorage.getItem("pk");
      let uuid = window.localStorage.getItem("uuid");
      this.axios.get(`japi/analysis/gethandle?uuid=${uuid}&pk=${pk}`).then((res) => {
        console.log("传入数据======");
        console.log(res);
        if (res.status == 200) {
          let arr = res.data.data;
          console.log(arr);
          let selfData = arr.filter((item) => item.id == pk)[0];
          let treeObj;
          this.defaultkey.push(selfData.id);
          if (selfData.tag == "i") {
            treeObj = selfData;
          } else {
            treeObj = {
              ...selfData,
              children: arr.filter((item) => item.tag == "i"),
            };
          }
          this.handleNodeClick(treeObj, true);
        } else {
          console.log("请求数据失败！");
          this.$message.error("请求数据失败！");
        }
      });
    },
    fetchSensitiveWords() {
      this.axios.get("/japi/lawConfig/getSensitiveWords?id=8888").then((res) => {
        if (res.data && res.data.code == 200) {
          this.sensitiveWords = res.data.data;
        }
      });
    },
    // 中间内容标红/标下划线
    getHightlightAndUnderline(treeData) {
      return treeData.map((item) => {
        return {
          ...item,
          labelHtml: this.getUnderLineStr(
            this.getHightlightStr(item.label, this.sensitiveWords, "#f49600"),
            this.cjfdList
          ),
          children: item.children.map((i) => {
            return {
              ...i,
              labelHtml: this.getUnderLineStr(
                this.getHightlightStr(i.label, this.sensitiveWords, "#f49600"),
                this.cjfdList
              ),
            };
          }),
        };
      });
    },
    //解析文件方法
    getFileDataFun() {
      this.loadingCategory = true;
      this.axios.get("/japi/analysis/handle/?pk=" + this.uuid).then((res) => {
        this.loadingCategory = false;
        if (res.data.code == 200) {
          console.log("解析文件成功======");
          console.log(res);
          window.localStorage.setItem("taskUuid", res.data.task_uuid); //任务的uuid
          this.title = res.data.title;
          this.centerTextType = res.data.type;
          this.treeData = res.data.data;
          this.head_content = res.data.head_content.replace(/\n/g, "<br/>"); //标题下方的简介
          this.chooseData = this.treeData; //中间选中的数据

          // 处理数据 - 将右侧敏感词标下划线;
          this.chooseData = this.getHightlightAndUnderline(this.treeData);
          //对应条款数据
          let objTitle = { id: this.uuid, label: "综合意见" }; //综合意见传uuid
          this.termsData.push(objTitle);
          this.treeData.forEach((item) => {
            let obj = { id: item.id, label: item.label };
            this.termsData.push(obj);
            item.children.forEach((item) => {
              let obj = { id: item.id, label: item.label };
              this.termsData.push(obj);
            });
          });
          this.process = res.data.process; //审查进度
          this.reviewOpinionDataFun(this.process); //审查意见列表数据

          if (window.localStorage.getItem("pk")) {
            this.initByPk();
          }
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },

    //右侧start=====
    //右侧一级标签切换
    radioChange(val) {
      this.inputTxt = ""; //清空检索数据
      this.currentPageDeclare = 1;
      this.searchType = undefined;
      this.dealSecondTitleDataFun(); //获取二级标签数据
      if (this.radioR != "LFZL") {
        this.$refs.advance_form.getAdvanceList(); //清空检索数据
        // this.recommendCnkiDataFun(1);//右侧推荐知网数据
        this.advancedList = [
          {
            field: undefined,
            value: undefined,
            compare: undefined,
          },
        ];
      }
    },
    //获取具体法规填充到依据和理由
    obtainLawFun(item) {
      if (!this.curMode) {
        this.curMode = "add";
        this.isShowAddReviewOpinions = true; //编辑审查意见显示
      }
      let str = "";
      // 法律法规库
      if (this.radioR == "CLKL") {
        // let str="云南省艾滋病防治条例 全国人民代表大会常务委员会 2013-06-29"
        str =
          item._source.zhongWenBiaoTi +
          item._source.tiaoMuXuHao +
          " " +
          item._source.faBuJiGuan +
          " " +
          item._source.faBuRiQi +
          "; ";
      }
      //政报公报库
      else if (this.radioR == "CJFZ") {
        str =
          item._source.pianMing +
          " " +
          item._source.zhongWenKanMing +
          " " +
          item._source.chuBanRiQi +
          "; ";
      }
      //参考知识库
      else if (this.radioR == "CLKD") {
        str =
          item._source.pianMing +
          " " +
          item._source.chuPanDanWei +
          " " +
          item._source.zuoZhe +
          " " +
          item._source.chuBanRiQi +
          "; ";
      }
      str = str.replaceAll("null", "").substring(0, str.length - 1); //去除最后一位；
      this.$nextTick(() => {
        this.$refs.addReviewOpinions.childrenFun(str, item, str, this.radioR); //第一个str为拼接的内容赋值给子组件（可修改） 第二个参数为点击的对象 第三个参数为拼接的内容 第四个为一级标签id
      });
    },
    //推荐知网数据标签
    recommendCnkiDataTitleFun() {
      this.axios.get("/japi/check/push_catalog_handle/").then((res) => {
        if (res.data.code == 200) {
          console.log("推荐知网标签数据成功======");
          console.log(res);
          this.firstTitleData = res.data.data;
          if (window.localStorage.getItem("gzid")) {
            this.radioR = "LFZL";
          } else {
            this.radioR = res.data.data[0].id;
          }
          this.dealSecondTitleDataFun(); //获取二级标签数据
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    //二级标签切换
    getidFun(id, index) {
      this.cur = index;
      this.secondId = id;
      this.currentPageDeclare = 1;
      if (this.inputTxt || this.advancedList[0].value) {
        this.recommendCnkiDataFun(1, "", "search"); //获取推荐知网数据
      } else {
        this.recommendCnkiDataFun(1); //右侧推荐知网数据
      }
      console.log(id);
    },
    //处理二级标签数据
    dealSecondTitleDataFun(page, tag, searchType, sentence) {
      //此处为一二级标签一起返回 通过一级标签获取二级标签
      // this.firstTitleData.forEach(item=>{
      // 	if(this.radioR==item.id){
      // 		this.secondTitleData=item.child;
      // 		this.secondId=item.child[0].id;
      // 		this.cur=0;
      // 	}
      // });
      this.recommendCnkiData = []; //先清空
      // this.loadingSecondTitle=true;//加载中显示
      this.startAllLoading();
      let url = ""; //请求的接口
      let params = {}; //参数
      let item_id = ""; //条的uuid
      //默认情况下currentKey为整篇的uuid //章的时候推全篇 tag=c
      // console.log(this.currentKey);
      // console.log(tag);
      // if(this.currentKey.indexOf('_')<0||tag=='c'){
      if (this.currentKey.indexOf("_") < 0 || this.checkedTreeObj.tag == "c") {
        item_id = "";
      } else {
        item_id = this.currentKey;
      }

      if (this.radioR == "LFZL") {
        this.recommendCnkiDataFun(1);
        return;
      }
      //一框检索获取二级标签
      if (searchType) {
        url = this.searchUrl[this.searchType];
        //法律法规库区分整篇和条
        if (this.radioR == "CLKL") {
          // item_id存在为条
          if (item_id || this.reviewType == "item") {
            params = {
              keyword: this.inputTxt,
              from: this.radioR + "T",
              type: "group",
              filedCondition: JSON.stringify(this.advancedList),
            };
          }
          // item_id不存在为篇
          else {
            params = {
              keyword: this.inputTxt,
              from: this.radioR + "P",
              type: "group",
              filedCondition: JSON.stringify(this.advancedList),
            };
          }
        }
        // 政报公报库和参考知识库只有篇
        else {
          params = {
            keyword: this.inputTxt,
            from: this.radioR,
            type: "group",
            filedCondition: JSON.stringify(this.advancedList),
          };
        }
      } else {
        console.log(this.radioR);
        //法律法规库
        if (this.radioR == "CLKL") {
          if (this.reviewType == "file") {
            url = "/japi/lawAIRec/get_law_article";
          }
          //条目审查
          else if (this.reviewType == "item") {
            url = "/japi/lawAIRec/get_law_item";
          }
          //url = "/japi/lawAIRec/get_law_article";
          params = {
            id: this.uuid, //整篇的uuid
            item_id: item_id, //条的uuid 没有就为空
            type: "group", //固定值
          };
        }
        //政报公报库
        else if (this.radioR == "CJFZ") {
          url = "/japi/lawAIRec/get_bulletin_article";
          params = {
            id: this.uuid, //整篇的uuid
            item_id: item_id, //条的uuid 没有就为空
            type: "group", //固定值
          };
        }
        //参考知识库
        else if (this.radioR == "CLKD") {
          url = "/japi/lawAIRec/getPaperArticle";
          params = {
            id: this.uuid, //整篇的uuid
            item_id: item_id, //条的uuid 没有就为空
            type: "group", //固定值
          };
        }
      }

      this.axios({
        method: "get",
        url: url,
        params: params,
      }).then((res) => {
        this.stopAllLoading();
        if (res.data.code == 200) {
          console.log("二级标签请求成功======");
          console.log(res);
          // this.loadingSecondTitle=false;//加载中消失

          //一框检索
          this.secondTitleData = res.data.data;
          if (res.data.data.list) {
            this.secondTitleData = res.data.data.list;
          }
          this.secondTitleData.unshift({ key: "ALL", value: "全部" }); //添加全部 默认选中
          if (this.secondTitleData && this.secondTitleData.length > 0) {
            // 没有二级分组默认选中全部
            // 当有二级分组且有【法律】默认选择【法律】
            if (
              this.secondTitleData.length > 1 &&
              this.secondTitleData[1].key == "0201"
            ) {
              this.secondId = this.secondTitleData[1].key;
              this.cur = 1;
            } else {
              this.secondId = this.secondTitleData[0].key;
              this.cur = 0;
            }
          }
          if (this.secondTitleData.length > 0) {
            this.maxSecondTitleStrLength = eval(
              this.secondTitleData.map((item) => item.value.length).join("+")
            );
          }
          if (searchType) {
            this.recommendCnkiDataFun(1, "", "search"); //获取推荐知网数据
          } else {
            if (sentence == "sentence") {
              this.recommendCnkiDataFun(1, "", "", "sentence"); //右侧推荐知网数据
            } else {
              this.recommendCnkiDataFun(1); //右侧推荐知网数据
            }
          }
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    //推荐知网数据
    recommendCnkiDataFun(page, tag, searchType, sentence) {
      this.startAllLoading();
      let url = ""; //请求的接口
      let params = {}; //参数
      let item_id = ""; //条的uuid
      //默认情况下currentKey为整篇的uuid //章的时候推全篇 tag=c
      if (this.currentKey.indexOf("_") < 0 || this.checkedTreeObj.tag == "c") {
        item_id = "";
      } else {
        item_id = this.currentKey;
      }

      //一框检索获取数据
      if (searchType) {
        this.sentenceCur = Number; //清除句子的当前高亮cur类
        // url = "/japi/lawAIRec/select";
        url = this.searchUrl[this.searchType];
        //法律法规库区分整篇和条
        if (this.radioR == "CLKL") {
          // item_id存在为条
          if (item_id || this.reviewType == "item") {
            params = {
              keyword: this.inputTxt,
              from: this.radioR + "T",
              effect_level: this.secondId, //二级标签当前id
              cur_page: page,
              limit: this.pageSize,
              filedCondition: JSON.stringify(this.advancedList),
            };
          }
          // item_id不存在为篇
          else {
            params = {
              keyword: this.inputTxt,
              from: this.radioR + "P",
              effect_level: this.secondId, //二级标签当前id
              cur_page: page,
              limit: this.pageSize,
              filedCondition: JSON.stringify(this.advancedList),
            };
          }
        }
        // 政报公报库和参考知识库只有篇
        else {
          params = {
            keyword: this.inputTxt,
            from: this.radioR,
            effect_level: this.secondId, //二级标签当前id
            cur_page: page,
            limit: this.pageSize,
            filedCondition: JSON.stringify(this.advancedList),
          };
        }
      } else {
        //法律法规库
        if (this.radioR == "CLKL") {
          this.inputTxt = ""; //清空检索词
          this.$refs.advance_form.getAdvanceList(); //清空检索数据
          //整篇审查
          if (this.reviewType == "file") {
            url = "/japi/lawAIRec/get_law_article";
          }
          //条目审查
          else if (this.reviewType == "item") {
            url = "/japi/lawAIRec/get_law_item";
          }
          // item_id存在就传 不存在就不传
          if (item_id) {
            //如果选中的句子存在就继续进行句子检索
            // if(sentence=='sentence'){
            if (this.sentenceContentCur) {
              params = {
                id: this.uuid, //整篇的uuid
                item_id: item_id, //条的uuid 没有就为空
                cur_page: page,
                limit: this.pageSize,
                effect_level: this.secondId, //二级标签当前id
                sentence: this.sentenceContentCur, //当前选中的句子 只有item_id存在的时候才传
              };
            } else {
              params = {
                id: this.uuid, //整篇的uuid
                item_id: item_id, //条的uuid 没有就为空
                cur_page: page,
                limit: this.pageSize,
                effect_level: this.secondId, //二级标签当前id
              };
            }
          } else {
            params = {
              id: this.uuid, //整篇的uuid
              // item_id:item_id,//条的uuid 没有就为空
              cur_page: page,
              limit: this.pageSize,
              effect_level: this.secondId, //二级标签当前id
            };
          }
        }
        //政报公报库
        else if (this.radioR == "CJFZ") {
          this.sentenceCur = Number; //清除句子的当前高亮cur类
          this.sentenceContentCur = ""; //清空选中的句子
          url = "/japi/lawAIRec/get_bulletin_article";
          params = {
            id: this.uuid, //整篇的uuid
            item_id: item_id, //条的uuid 没有就为空
            cur_page: page,
            limit: this.pageSize,
            class_code: this.secondId, //二级标签当前id
          };
        }
        //参考知识库
        else if (this.radioR == "CLKD") {
          this.sentenceCur = Number; //清除句子的当前高亮cur类
          this.sentenceContentCur = ""; //清空选中的句子
          url = "/japi/lawAIRec/getPaperArticle";
          params = {
            id: this.uuid, //整篇的uuid
            item_id: item_id, //条的uuid 没有就为空
            cur_page: page,
            limit: this.pageSize,
            class_code: this.secondId, //二级标签当前id
          };
        }
        // 立法资料
        else if (this.radioR == "LFZL") {
          console.log("立法资料");
          this.sentenceCur = Number; //清除句子的当前高亮cur类
          this.sentenceContentCur = ""; //清空选中的句子
          url = "/japi/analysis/legal";
          params = {
            gzid: window.localStorage.getItem("gzid"), //整篇的uuid
          };
        }
      }

      this.axios({
        method: "get",
        url: url,
        params: params,
      }).then((res) => {
        this.stopAllLoading();
        this.advancedShow = false; //高级检索消失
        if (res.data.code == 200 || res.data.success) {
          console.log("推荐知网数据成功======" + searchType + sentence);
          // //法律法规库
          // if(this.radioR=="CLKL"){
          // 	this.recommendCnkiData=res.data.data.hits.hits;
          // 	if(res.data.data.hits.total.value){
          // 		this.total=res.data.data.hits.total.value;
          // 		// 默认200条
          // 		// this.total=200;
          // 	}else{
          // 		this.total=0;
          // 	}
          // }else{
          // 	this.recommendCnkiData=res.data.data.hits.hits;
          // 	// this.recommendCnkiDataSum=res.data.data.sum_count;
          // 	if(res.data.data.hits.total.value){
          // 		this.total=res.data.data.hits.total.value;
          // 		// 默认200条
          // 		// this.total=200;
          // 	}else{
          // 		this.total=0;
          // 	}
          // }

          // java接口返回数据处理
          console.log("java数据处理===用于高亮关键词");
          this.cjfdList = res.data.data.cjfdList || [];
          if (this.radioR != "LFZL") {
            this.recommendCnkiData = res.data.data.page.list.map((item) => {
              return {
                highlight: {
                  quanWen: this.getHightlightStr(
                    item.quanWen,
                    res.data.data.cjfdList || []
                  ),
                },
                _source: {
                  ...item,
                  zhongWenZhaiYao: this.getHightlightStr(
                    item.zhongWenZhaiYao,
                    res.data.data.cjfdList || []
                  ),
                },
              };
            });

            this.total = res.data.data.page.total || 0;
          } else {
            console.log("设置立法资料数据", res.data.data);
            // this.recommendCnkiData = [];
            this.recommendCnkiData = res.data.data;
          }

          //解析文件方法-获取中间内容
          if (this.chooseData.length == 0) {
            // 不重复获取数据
            this.getFileDataFun();
          } else {
            this.loadingCategory = false; //不需要加载目录
            // 右侧cjfdList数据改变，重新标下划线
            this.chooseData = this.getHightlightAndUnderline(this.chooseData);
          }
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },

    //分页
    handleSizeChangeDeclare(size) {
      // console.log(`每页 ${size} 条`);
      this.pageSize = size;
      // this.recommendCnkiDataFun(this.currentPageDeclare);//推荐知网数据
      if (this.inputTxt || this.advancedList[0].value) {
        this.recommendCnkiDataFun(this.currentPageDeclare, "", "search"); //获取推荐知网数据
      } else {
        this.recommendCnkiDataFun(this.currentPageDeclare); //推荐知网数据
      }
    },
    handleCurrentChangeDeclare(currentPage) {
      // console.log(`当前页: ${currentPage}`);
      this.currentPageDeclare = currentPage;
      // this.recommendCnkiDataFun(this.currentPageDeclare);//推荐知网数据
      if (this.inputTxt || this.advancedList[0].value) {
        this.recommendCnkiDataFun(this.currentPageDeclare, "", "search"); //获取推荐知网数据
      } else {
        this.recommendCnkiDataFun(this.currentPageDeclare); //推荐知网数据
      }
    },

    //点击某一句话时右侧的正文快照与之相同的文字高亮显示
    highlightFontFun(val) {
      // this.sentenceContentCur="艾滋病";
      if (val.indexOf(this.sentenceContentCur) < -1) {
        return val;
      } else {
        return val.replace(
          this.sentenceContentCur,
          '<font color="#F00">' + this.sentenceContentCur + "</font>"
        );
      }
    },
    //右侧end=====

    //左侧start====
    //重置功能
    resetChecked() {
      this.sentenceCur = Number; //清除句子的当前高亮cur类
      this.currentKey = this.uuid;
      this.chooseData = this.treeData;
      this.$refs.tree.setCheckedKeys([]);
      this.reviewOpinionDataFun(this.process); //审查意见列表数据
      this.recommendCnkiDataFun(1); //右侧推荐知网数据
    },
    //树形控件实现单选功能
    handleNodeClick(data, checked, node, type) {
      console.log(data);
      if (checked === true) {
        console.log(data);
        // console.log(checked);
        // console.log(node);
        this.sentenceCur = Number; //清除句子的当前高亮cur类
        this.checkedTreeObj = {}; //选中的标签数据
        this.checkedTreeObj = data;
        // console.log("length"+this.checkedTreeObj.length);
        // console.log("length-data"+data.length);
        if (type == "add") {
          //添加时只选中导航节点即可
          this.$refs.tree.setCheckedKeys([data.id]);
          this.reviewOpinionDataFun(this.process); //审查意见列表数据
        } else {
          this.sentenceContentCur = ""; //清空选中的句子
          this.currentKey = data.id;
          this.$refs.tree.setCheckedKeys([data.id]);
          this.getCenterChooseDataFun(); //筛选数据
          //标签右侧不请求数据
          // if(data.tag!="c"){
          // this.recommendCnkiDataFun(1,data.tag);//右侧知网数据
          this.dealSecondTitleDataFun(1, data.tag); //获取二级标签数据
          // }
          this.reviewOpinionDataFun(this.process); //审查意见列表数据
        }
      } else {
        if (this.currentKey == data.id) {
          this.$refs.tree.setCheckedKeys([data.id]);
        }
      }
      // let res = this.$refs.tree.getCheckedNodes();
      // this.checkedId2=res;
      // this.currentKey=this.$refs.tree.getCheckedNodes();
    },
    //获取中间选中的数据
    getCenterChooseDataFun() {
      console.log("设置中间内容");
      // 切换数据
      this.treeData.forEach((item) => {
        if (item.id == this.currentKey) {
          this.chooseData = [];
          this.chooseData.push(item);
          this.chooseData = this.getHightlightAndUnderline(this.chooseData);
        } else {
          item.children.forEach((item) => {
            if (item.id == this.currentKey) {
              this.chooseData = [];
              let obj = { label: "", children: [] };
              obj.children.push({
                ...item,
                labelHtml: this.getUnderLineStr(
                  this.getHightlightStr(item.label, this.sensitiveWords, "#f49600"),
                  this.cjfdList
                ),
              });
              this.chooseData.push(obj);
            }
          });
        }
      });
    },
    startAllLoading() {
      this.loadingCategory = true;
      this.loadingcnkiData = true;
      this.loadingCheckDataList = true;
      console.log("startAllLoading");
    },
    stopAllLoading() {
      this.loadingCategory = false;
      this.loadingcnkiData = false;
      this.loadingCheckDataList = false;
      console.log("stopAllLoading");
    },
    //审查意见列表数据
    reviewOpinionDataFun() {
      let me = this;
      me.loadingCheckDataList = true;
      this.axios
        .get(
          "/japi/check/check_advices_handle/?tag=all&uuid=" +
            this.currentKey +
            "&page=1&page_num=10000000&process=" +
            this.process
        )
        .then((res) => {
          me.loadingCheckDataList = false;
          if (res.data.code == 200) {
            if (res.data.data) {
              this.reviewOpinionData = res.data.data.res;
            } else {
              this.reviewOpinionData = [];
            }
          } else if (res.data.code == 500) {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
    },
    //审查意见列表更多
    toReviewOpinionFun() {
      //跳转审查意见页面
      this.$router.push({ path: "/recordReview/reviewOpinion" });
      // this.$router.push("/refresh"); //保证审查意见标签选中
    },
    //编辑意见
    editOpinionFun(id) {
      this.curMode = "edit";
      // this.currentKey="";//当前编辑意见的具体对应条款
      // this.type="";//建议类型
      this.isShowAddReviewOpinions = true;
      this.$nextTick(() => {
        this.$refs.addReviewOpinions.getDataFun(id); //触发子组件获取数据的方法
      });
    },
    parentDelReviewOpinionsFun() {
      this.$nextTick(() => {
        this.reviewOpinionDataFun();
      });
    },
    //编辑意见完成后触发父组件的方法
    parentAddReviewOpinionsFun() {
      this.isShowAddReviewOpinions = false;
      this.curMode = ""; //清空
      this.$nextTick(() => {
        this.defaultkey.push(this.checkedTreeObj.id);
        this.handleNodeClick(this.checkedTreeObj, true, 0, "add"); //触发点击事件
      });
    },
    //将时间中的T换成空格
    handleTime(t) {
      t = t.replace(new RegExp(/(T)/g), "\u00a0");
      return t;
    },
    //左侧end====

    //中间start====
    //添加意见
    addOpinionFun() {
      this.curMode = "add";
      this.isShowAddReviewOpinions = true;
      this.showL = true;
    },
    //重新上传
    uploadAgainFun() {
      this.$confirm("请确认是否要重新上传新文档替换当前智能审查原文文档？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false, //是否可通过点击遮罩关闭MessageBox
      })
        .then(() => {
          //确定
          this.$refs.uploadAgain.childFun();
          // let uuid=this.multipleSelection[0].uuid;
          // this.axios({
          // 	method: "post",
          // 	url: "/api/check/check_items_handle/",
          // 	data:{ //请求参数放在请求体
          // 		uuid:uuid
          // 	}
          // }).then(res => {
          // 	if (res.data.code == 200) {
          // 		console.log("删除成功======");
          // 		console.log(res);
          // 		//遮罩隐藏
          // 		this.loadingFile=false;
          // 		this.$message({
          // 			message: "删除成功",
          // 			type: "success",
          // 			duration: 3000
          // 		});
          // 		this.tableFun(this.currentPageDeclare);
          // 	} else if(res.data.code == 500){
          // 		this.$message({
          // 			message: "删除失败，请重新删除！",
          // 			type: "warning",
          // 			duration: 3000
          // 		});
          // 	}
          // });
          // this.tableFun(1);
        })
        .catch(() => {
          //不加catch会报错
          this.$message({
            type: "info",
            message: "已取消重新上传",
          });
        });
    },
    //生成报告
    generateReportFun() {
      this.$confirm(
        "请确认是否已完成本次智能审查意见编辑工作，由系统自动生成智能审查报告？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false, //是否可通过点击遮罩关闭MessageBox
        }
      )
        .then(() => {
          //确定
          //遮罩显示
          this.loadingReport = true;

          let formData = new FormData();
          formData.append("item_uuid", this.uuid); //条目的uuid
          formData.append("process", this.process); //审查进度
          this.axios({
            method: "post",
            url: "/japi/check/report_handle/",
            data: formData,
          }).then((res) => {
            console.log(res);
            //遮罩隐藏
            this.loadingReport = false;
            if (res.data.code == 200) {
              console.log("生成报告成功======");
              console.log(res);
              this.$message({
                message: "生成报告成功",
                type: "success",
                duration: 3000,
              });
              //将存储到localStorage
              window.localStorage.setItem("report_id", res.data.data.report_id);
              window.localStorage.setItem("reviewStage", "report"); //审查进度 智能审查 "checking"  生成报告 "report" 完成审查 "done"
              //跳转生成报告
              this.$router.push({ path: "/recordReview/generateReport" });
            } else if (res.data.code == 500) {
              this.$message({
                // message: "生成报告失败，请重新上传！",
                message: res.data.msg,
                type: "warning",
                duration: 3000,
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "warning",
                duration: 3000,
              });
            }
          });
        })
        .catch(() => {
          //不加catch会报错
          this.$message({
            type: "info",
            message: "已取消生成报告",
          });
        });
    },
    //点击获取当前id值
    centerCurIdFun(item) {
      // console.log(item);
      console.log("点击的是条");
      this.defaultkey.push(item.id);
      this.handleNodeClick(item, true); //触发点击事件
      this.currentKey = item.id;
      // this.$refs.tree.setCurrentNode(item);
      // this.getCenterChooseDataFun();
    },

    //分割数据
    splitData(str) {
      let arr = str.split("。");
      arr.pop(); //去除数组中的最后一个元素。
      // console.log(arr);
      return arr;
    },
    //点击某句话
    clickSentenceFun(item, index) {
      //e.stopPropagation();//阻止事件向上冒泡
      this.sentenceCur = index;
      this.sentenceContentCur = item; //句子当前选中的内容
      console.log(item + "。");
      console.log("点击的是句子");
      // this.highlightFontFun();
      this.dealSecondTitleDataFun("", "", "", "sentence"); //需要获取二级标签 避免检索之后再点击句子时没有二级标签
      // this.recommendCnkiDataFun(1,"","",'sentence');//右侧推荐知网数据
    },

    //中间end====
  },
  computed: {
    //vue-seamless-scroll配置 文字滑动
    optionSwitch1() {
      return {
        autoPlay: false, //自动轮播
        switchSingleStep: 446, //轮播一次的宽度 为一屏的宽度 小于这个值不能滚动
        navigation: true, //左右滚动是否显示控制器按钮
        limitMoveNum: 100, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, //往左滚动 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        // isSingleRemUnit:true //	singleHeight and singleWidth是否开启rem度量
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/mixin.scss"; //定义方法
@import "../../../../assets/css/recordReviewDetail.scss"; //智能审查详情页样式
</style>
